<div class="container-xxl">
	<section class="modifica">
		<h2>{{ "user.consents" | translate }}</h2>
		<div class="form-modifica">
			<form
				name="registrationForm"
				[formGroup]="userForm"
				enctype="application/x-www-form-urlencoded"
			>
				<div class="row">
					<div class="col-sm-12">{{ "consensi.privacy" | translate }}</div>
				</div>

				<div class="d-sm-table-row">
					<div class="col-sm-12 text-center">
						<input
							type="radio"
							name="consent1"
							[value]="true"
							formControlName="consent1"
						/>
						{{ "user.agree" | translate }}
						<input
							type="radio"
							name="consent1"
							[value]="false"
							formControlName="consent1"
						/>
						{{ "user.disagree" | translate }}
					</div>
					<div class="col-sm-12">
						<div>
							<p
								dir="ltr"
								style="text-align: center"
							>
								<strong>
									<span style="font-size: 14px">
										<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-1.p1" | translate }}</span>
									</span>
								</strong>
							</p>
							<p dir="ltr">
								<span style="font-size: 14px">
									<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-1.p2" | translate }}</span>
								</span>
							</p>
						</div>
					</div>
				</div>

				<div class="d-sm-table-row">
					<div class="col-sm-12 text-center">
						<input
							type="radio"
							name="consent2"
							[value]="true"
							formControlName="consent2"
						/>
						{{ "user.agree" | translate }}
						<input
							type="radio"
							name="consent2"
							[value]="false"
							formControlName="consent2"
						/>
						{{ "user.disagree" | translate }}
					</div>
					<div class="col-sm-12">
						<div>
							<p
								dir="ltr"
								style="text-align: center"
							>
								<strong>
									<span style="font-size: 14px">
										<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-2.p1" | translate }}</span>
									</span>
								</strong>
							</p>
							<p dir="ltr">
								<span style="font-size: 14px">
									<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-2.p2" | translate }}</span>
								</span>
							</p>
						</div>
					</div>
				</div>

				<div class="d-sm-table-row">
					<div class="col-sm-12 text-center">
						<input
							type="radio"
							name="consent3"
							[value]="true"
							formControlName="consent3"
						/>
						{{ "user.agree" | translate }}
						<input
							type="radio"
							name="consent3"
							[value]="false"
							formControlName="consent3"
						/>
						{{ "user.disagree" | translate }}
					</div>
					<div class="col-sm-12">
						<div>
							<p
								dir="ltr"
								style="text-align: center"
							>
								<strong>
									<span style="font-size: 14px">
										<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-3.p1" | translate }}</span>
									</span>
								</strong>
							</p>
							<p dir="ltr">
								<span style="font-size: 14px">
									<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-3.p2" | translate }}</span>
								</span>
							</p>
						</div>
					</div>
				</div>

				<div class="col-sm-12 text-center">
					<span id="step1_inserisci_fieldsContainer">
						<a
							(click)="save()"
							[class.disabled]="userForm.invalid"
							class="btn btn-red"
						>
							{{ "userProfile.save" | translate }}
						</a>
					</span>
				</div>
			</form>
		</div>
	</section>
</div>